<template>
  <div class="order-box">
    <div class="order-content">
      <div class="list">
        <ul>
        <li>
          <div class="Order">
              <p><b>订单名称：{{item.orderInfo.orderName}}</b></p>
             <p>订单编号：{{item.orderInfo.orderNo}}</p>
             <div v-if="item.orderInfo.orderStatus == 5">
               <p>支付类型：{{item.orderInfo.payType == 1?'线上支付':'线下支付'}}</p>
               <p v-if="item.orderInfo.payType == 1">支付方式：微信</p>
             </div>
             <p><b>创建时间：{{item.orderInfo.orderTime}}</b></p>
              <p :class="{'order-title': item.orderInfo.orderStatus == 2}" :title="item.orderInfo.orderName">
                <b>缴费金额：￥{{item.orderInfo.amount}}</b>
                <span :class="{success: item.statue == 5}">状态：<i>{{item.orderInfo.orderStatus | statue}}</i></span>
              </p>
             <div class="voucher"  v-if="item.orderInfo.offlineVoucher && PZUrl">
              <p>缴费凭证:</p>
              <div class="images" v-viewer="{movable: false}">
               <img :src="PZUrl" class="pic" />
              </div>
             </div>
          </div>
          <div class="buttonBox" v-if="item.orderInfo.orderStatus == 2">
             <van-button type="plain" @click="cancel">取消订单</van-button>
             <p>
             <!-- <van-button type="info" @click="onLine" v-if="isWXPay">线上支付</van-button> -->
             <van-button plain type="primary"  @click="gopath(item)">线下支付</van-button>
             </p>
          </div>

        <div v-if="this.showPayUndeLine">
                <offlinePaymentHydro :orderId="this.orderId" :memberId="this.memberId" @a="a"></offlinePaymentHydro>
            </div>

        </li>    
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import { getPZUrl, paymentCancel, cancelMeetingOrder } from "@/api/dictionary";
import { Uploader,Toast,Button,ImagePreview,Dialog } from "vant";
import offlinePaymentHydro from "../../../views/MeetingCenter/signUpMeeting/offlinePaymentHydro.vue";
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    from: {
      type: String,
      default: ""
    },
    isWXPay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      PZUrl: "",
      orderId:'',
      showPayUndeLine:false,
      memberId:''
    };
  },
  filters: {
    statue(val) {
      switch (val) {
        case 1:
          return "已删除";
          bredk;
        case 2:
          return "待支付";
          bredk;
        case 3:
          return "已取消";
          bredk;
        case 4:
          return "已支付";
          bredk;
        case 5:
          return "订单完成";
          bredk;
      }
    }
  },
  components: {
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [ImagePreview.name]: ImagePreview,
    [Dialog.name]: Dialog,
    offlinePaymentHydro
  },
   computed:{
    //     id() {
    //       return this.$route.query && this.$route.query.meetingId;
    //     }
	},
  methods: {
    gopath(item) {
     
        // let params = {};
        // params.orderId = this.item.orderInfo.id;
        // this.$router.push({ name: 'offlinePaymentHydro' ,query:params});
        if(this.showPayUndeLine == true){
            this.showPayUndeLine = false;
        }else{
            this.showPayUndeLine = true;
        }
        this.memberId = item.orderInfo.memberId;
        this.orderId = item.orderInfo.id;
    },
    a(){
      this.$emit("c");
      this.showPayUndeLine = false;
    },
    show() {
      const viewer = this.$el.querySelector(".images").$viewer;
      viewer.show();
    },
    onLine() {
      this.$emit("onLine", this.item.orderInfo);
    },
    underLine() {
      this.$router.push({
        name: "payUndeLine",
        params: { id: this.item.orderInfo.id },
        query: { form: this.from }
      });
    },
    cancel() {
      let params = {
        orderId: this.item.orderInfo.id
      };
    Dialog.confirm("确认删除订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
      // on confirm
      if (this.from == "meetingUndeLine") {
            this.meetingCancel(params);
          } else {
            this.paymentCancel(params);
          }
    }).catch(() => {
      // on cancel
    });
    },
    paymentCancel(params) {
      paymentCancel(params).then(res => {
        Toast.success("取消成功！");
        this.$emit("getDate", this.item);
      });
    },
    meetingCancel(params) {
      cancelMeetingOrder(params).then(res => {
        if (res.success) {
          this.$emit("getDate", this.item);
        } else {
          Toast.fail("创建订单失败");
        }
      });
    },
    deleteOrder() {
      let params = {
        meetingId: this.item.meeting.id,
        memberId: sessionStorage.getItem("memberId")
      };

      this.$confirm("确认删除订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteMeetingOrder(params).then(res => {
            if (res.success) {
              this.$emit("update");
            } else {
              Toast.fail("创建订单失败");
            }
          });
        })
        .catch(() => {});
    },
    //获取凭证
    getDisplay(offlineVoucher) {
      let params = {
        id: offlineVoucher
      };

      if (!offlineVoucher) return;

      getPZUrl(params).then(res => {
        if (res.success) {
          this.PZUrl = res.result;
        }
      });
    }
  },
  mounted() {
    this.getDisplay(this.item.orderInfo.offlineVoucher);
  }
};
</script>

<style scoped lang="less">

.content ul li{ 
  border-bottom: #f2f2f2 solid 8px;
  padding:20px 0 15px 0;
    p{
      overflow: hidden; padding:0 20px; 
      b{ float: left; display: block; line-height: 28px; }
      span{ 
        display: block; 
        float: right;
        font-size: 14px;
        line-height: 28px;
        i{
          color: #ea4848;
         }
        }
     }
    }
.Order{ background: #fafafa; padding:15px 0; }
.Order p{ line-height: 32px; color: #848484; font-size: 14px; }
.imgBox{ 
  padding:20px; 
    img{ width: 100%; }
} 
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
.buttonBox{
  margin-top: 15px;
  overflow: hidden;
  height: 36px;
  .van-button{ border:none; height: 35px; line-height: 30px; margin-left: 10px; }
  p{ float: right;;}
}
.van-button--plain.van-button--primary,.van-button--info{  border:1px solid #228ccd !important;}
.images{ margin-left: 20px; }
.voucher img{ width:80px; height: 30px; }
</style>


